<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header @back="goBack" content="任务详情"></el-page-header>
        </div>
      </div>
    </div>

    <section class="uc-examList">
      <div class="item">
        <div class="title">
          <div class="c el-icon-s-operation">
            {{ model.title }}
          </div>
        </div>
        <div class="con">
          <div class="sub-item w50">
            <i class="el-icon-s-custom"></i> 创建人：{{
              model.create_user_name
            }}
          </div>
          <div class="sub-item w50">
            <i class="el-icon-time"></i> 任务期限：{{ model.start_time }} ~
            {{ model.finish_time }}
          </div>
          <div
            v-bind:class="{ expansion: model.is_long_content }"
            class="sub-item w100"
            v-html="`<i class=el-icon-document></i> 任务内容：${model.content}`"
          ></div>
          <el-button
            type="text"
            v-if="model.is_show_content"
            v-on:click="model.is_long_content = !model.is_long_content"
          >
            <span
              v-html="
                model.is_long_content
                  ? '展开内容<i class=el-icon-arrow-down></i>'
                  : '收起内容<i class=el-icon-arrow-up></i>'
              "
            >
            </span>
          </el-button>
          <div
            v-bind:class="{ expansion: model.is_long_objective }"
            class="sub-item w100"
            v-html="
              `<i class=el-icon-document></i> 达成目标：${model.objective}`
            "
          ></div>
          <div class="sub-item w100">
            <el-button
              type="text"
              v-if="model.is_show_objective"
              v-on:click="model.is_long_objective = !model.is_long_objective"
            >
              <span
                v-html="
                  model.is_long_objective
                    ? '展开目标<i class=el-icon-arrow-down></i>'
                    : '收起目标<i class=el-icon-arrow-up></i>'
                "
              >
              </span>
            </el-button>
          </div>
          <div class="sub-item w100">
            <i class="el-icon-user"></i> 任务对象：
            <span v-for="(item, index) in model.task_users" :key="index">
              {{
                (index == model.task_users.length - 1 &&
                  item.apprentice_name) ||
                  item.apprentice_name + '，'
              }}
            </span>
          </div>
          <div class="sub-item w100">
            <i class="el-icon-connection"></i> 任务状态：<span
              v-if="model.approval_status == 0"
            >
              <el-tag type="warning" size="small">
                {{ model.approval_status_text }}
              </el-tag>
              <i class="el-icon-arrow-right"></i>
              <el-button
                type="text"
                v-on:click="
                  dialogApprovalVisible = true;
                  approvalForm.id = model.id;
                "
                >去审核</el-button
              >
            </span>
            <span v-else-if="model.approval_status == 1">
              <el-tag type="success" size="small">
                {{ model.approval_status_text }}
              </el-tag>
            </span>
            <span v-else>
              <el-tag type="danger" size="small">
                {{ model.approval_status_text }}
              </el-tag>
              <i class="el-icon-arrow-right"></i>
              <el-button
                type="text"
                v-on:click="handleClickReason(`${model.approval_reason}`)"
                >驳回原因</el-button
              >
            </span>
          </div>
          <div class="sub-item w100" v-if="model.approval_status == 1">
            <i class="el-icon-s-grid"></i> 反馈情况：
            <div v-for="(item, index) in model.task_users" :key="index">
              <i class="el-icon-caret-right"></i> {{ item.apprentice_name }}
              <i class="el-icon-arrow-right"></i>
              <span v-if="item.feedback">
                <span v-if="item.approval_status == 0">
                  <el-tag type="warning" size="small">
                    {{ item.approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      dialogFeedbackVisible = true;
                      getFeedbackDetails(item);
                    "
                    >查看反馈</el-button
                  >
                </span>
                <span v-else-if="item.approval_status == 1">
                  <el-tag type="success" size="small">
                    {{ item.approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      dialogFeedbackDetailsVisible = true;
                      getFeedbackDetails(item);
                    "
                    >查看评论</el-button
                  >
                </span>
                <span v-else>
                  <el-tag type="danger" size="small">
                    {{ item.approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="handleClickReason(`${item.approval_reason}`)"
                    >驳回原因</el-button
                  >
                </span>
              </span>
              <span v-else
                ><el-tag type="info" size="small">未反馈</el-tag></span
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <el-dialog
      title="任务审核"
      :visible.sync="dialogApprovalVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseApprovalDialog"
    >
      <el-form :model="approvalForm" ref="approvalForm" :rules="approvalRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="approvalForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="审核状态"
          prop="approval_status"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="approvalForm.approval_status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="通过"
            inactive-text="驳回"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="驳回原因"
          prop="approval_reason"
          :label-width="formLabelWidth"
          v-if="!approvalForm.approval_status"
        >
          <el-input
            type="textarea"
            v-model.trim="approvalForm.approval_reason"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleApproval">取 消</el-button>
        <el-button type="primary" @click.native="handleApprovalSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="任务反馈"
      :visible.sync="dialogFeedbackVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form :model="feedbackForm" ref="feedbackForm" :rules="feedbackRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="feedbackForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="反馈内容"
          prop="feedback"
          :label-width="formLabelWidth"
        >
          <span v-html="feedbackForm.feedback"></span>
        </el-form-item>
        <el-form-item
          label="反馈附件"
          prop="feedback_url"
          :label-width="formLabelWidth"
        >
          <span v-if="feedbackForm.feedback_url">
            <i class="el-icon-link"></i>
            <el-link
              :underline="false"
              :href="feedbackForm.feedback_url"
              target="_blank"
              type="primary"
              >下载</el-link
            >
          </span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item
          label="审核状态"
          prop="feedback_status"
          :label-width="formLabelWidth"
        >
          <el-switch
            style="display: inline;"
            v-model="feedback_status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="通过"
            inactive-text="驳回"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="驳回原因"
          prop="approval_reason"
          :label-width="formLabelWidth"
          v-if="!feedback_status"
        >
          <el-input
            type="textarea"
            v-model.trim="feedbackForm.approval_reason"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="评分"
          prop="score"
          :label-width="formLabelWidth"
          v-if="feedback_status"
        >
          <el-rate
            v-model="feedbackForm.score"
            style="line-height:2.8;"
          ></el-rate>
        </el-form-item>
        <el-form-item
          label="实际完成"
          prop="actual_finish_time"
          :label-width="formLabelWidth"
          v-if="feedback_status"
        >
          <el-date-picker
            v-model="feedbackForm.actual_finish_time"
            type="date"
            placeholder="选择实际完成日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="评论内容"
          prop="evaluation"
          :label-width="formLabelWidth"
          v-if="feedback_status"
        >
          <el-input
            type="textarea"
            v-model.trim="feedbackForm.evaluation"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleFeedback">取 消</el-button>
        <el-button type="primary" @click.native="handleFeedbackSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="任务反馈"
      :visible.sync="dialogFeedbackDetailsVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form :model="feedbackForm" ref="feedbackForm">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="feedbackForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="反馈内容"
          prop="feedback"
          :label-width="formLabelWidth"
        >
          <span v-html="feedbackForm.feedback"></span>
        </el-form-item>
        <el-form-item
          label="反馈附件"
          prop="feedback_url"
          :label-width="formLabelWidth"
        >
          <span v-if="feedbackForm.feedback_url">
            <i class="el-icon-link"></i>
            <el-link
              :underline="false"
              :href="feedbackForm.feedback_url"
              target="_blank"
              type="primary"
              >下载</el-link
            >
          </span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="评分" prop="score" :label-width="formLabelWidth">
          <el-rate
            v-model="feedbackForm.score"
            disabled
            show-score
            score-template="{value}分"
            style="line-height:2.8;"
          ></el-rate>
        </el-form-item>
        <el-form-item
          label="实际完成"
          prop="actual_finish_time"
          :label-width="formLabelWidth"
        >
          <span>{{ feedbackForm.actual_finish_time }}</span>
        </el-form-item>
        <el-form-item
          label="评论内容"
          prop="evaluation"
          :label-width="formLabelWidth"
        >
          <span v-html="feedbackForm.evaluation"></span>
        </el-form-item>
        <el-form-item
          label="评论人"
          prop="approval_user_name"
          :label-width="formLabelWidth"
        >
          <span
            v-html="
              `${feedbackForm.approval_user_name} · ${feedbackForm.approval_time}`
            "
          ></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click.native="dialogFeedbackDetailsVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MasterTaskDetails',
  data() {
    return {
      model: {},
      query: {
        type: 1,
        id: this.$route.params.id,
      },
      list: [],
      formLabelWidth: '100px',
      feedback_status: true,
      dialogFeedbackDetailsVisible: false,
      dialogFeedbackVisible: false,
      feedbackForm: {
        id: 0,
        task_id: 0,
        feedback: '',
        feedback_url: '',
        approval_status: '',
        approval_reason: '',
        evaluation: '',
        score: 0,
        actual_finish_time: '',
        approval_user_name: '',
        approval_time: '',
      },
      feedbackRules: {
        approval_reason: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' },
        ],
        evaluation: [
          { required: true, message: '请输入评价内容', trigger: 'blur' },
        ],
        score: [{ required: true, message: '请输入评分', trigger: 'blur' }],
        actual_finish_time: [
          { required: true, message: '请选择实际完成日期', trigger: 'blur' },
        ],
      },
      dialogApprovalVisible: false,
      approvalForm: {
        id: 0,
        approval_status: true,
        approval_reason: '',
      },
      approvalRules: {
        approval_reason: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getTaskDetails();
    },
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
    // 获取任务详情
    async getTaskDetails() {
      const response = await this.$api.shitu.getTaskDetails(this.query);
      const { code, message, data } = response.data;
      if (code === 200) {
        this.model = data;
      } else {
        this.$message.warning(message);
        this.goBack();
      }
    },
    // 获取任务反馈详情
    async getFeedbackDetails(item) {
      this.$nextTick(() => {
        this.feedbackForm = item;
        // console.log(this.feedbackForm);
      });
    },
    // ------------------任务审核-Begin------------------
    async editTaskApproval(task) {
      const response = await this.$api.shitu.editTaskApproval(task);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogApprovalVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.approvalForm.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleApprovalSubmitSure() {
      const submitData = {
        id: this.approvalForm.id,
        approval_status: this.approvalForm.approval_status ? 1 : 2,
        approval_reason: this.approvalForm.approval_reason,
      };
      this.$refs.approvalForm.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editTaskApproval(submitData);
        }
      });
    },
    handleCloseApprovalDialog() {
      this.$refs.approvalForm.resetFields();
    },
    handleCancleApproval() {
      this.dialogApprovalVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.approvalForm.resetFields();
      });
    },
    // 查看驳回原因
    handleClickReason(reason) {
      this.$alert(reason, '驳回原因', {
        dangerouslyUseHTMLString: true,
      });
    },
    // ------------------任务审核-End------------------

    // ------------------任务反馈评论-Begin------------------
    // 查看驳回原因
    handleClickReason(reason) {
      this.$alert(reason, '驳回原因', {
        dangerouslyUseHTMLString: true,
      });
    },
    async editFeedbackApproval(feedback) {
      const response = await this.$api.shitu.editFeedbackApproval(feedback);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogFeedbackVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.feedbackForm.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交数据
    handleFeedbackSubmitSure() {
      const submitData = {
        id: this.feedbackForm.id,
        task_id: this.feedbackForm.task_id,
        approval_status: this.feedback_status ? 1 : 2,
        approval_reason: this.feedbackForm.approval_reason,
        apprentice_id: this.feedbackForm.apprentice_id,
        evaluation: this.feedbackForm.evaluation,
        score: this.feedbackForm.score,
        actual_finish_time: this.feedbackForm.actual_finish_time,
      };
      if (this.feedbackForm.score === 0 && this.feedback_status) {
        this.$message.warning(`请选择评分！`);
      } else {
        this.$refs.feedbackForm.validate((valid) => {
          if (valid) {
            // 请求
            // console.log(submitData);
            this.editFeedbackApproval(submitData);
          }
        });
      }
    },
    handleCancleFeedback() {
      this.dialogFeedbackVisible = false;
    },
    handleCancleFeedbackDetails() {
      this.dialogFeedbackDetailsVisible = false;
    },
    // ------------------任务反馈评论-End------------------
  },
};
</script>
